import {NgModule} from '@angular/core';
import {COMPONENTS, SERVICES} from './index';
import {SharedModule} from '../shared/shared.module';
import {CheckboxModule} from 'primeng/checkbox';
import {TableModule} from 'primeng/table';
import {PaginatorModule} from 'primeng/paginator';
import {RippleModule} from 'primeng/ripple';
import {NotesModule} from '../notes/notes.module';
import {tablelistReducer} from './store/tablelist.reducer';
import {ClickOutsideModule} from 'ng-click-outside';
import {StoreModule} from '@ngrx/store';
import {CoreModule} from '@ispm/core/core.module';
import {TestModule} from '@ispm/test/test.module';
import {UserModule} from '@ispm/user/user.module';
import {LayoutModule} from '@ispm/layout/layout.module';
import {TherapiesModule} from '@ispm/therapies/therapies.module';
import {TranslateModule} from '@ngx-translate/core';
import {FilterModule} from '../filter/filter.module';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {ExportModule} from '../export/export.module';
import {WorklistExecuteComponent} from './components/worklist-execute/worklist-execute.component';
import {TablelistEffects} from './store/tablelist.effect';
import {EffectsModule} from '@ngrx/effects';
import {ContextMenuModule} from '@wuitk/angular/components/context-menu';
import {CommonModule as DlsCommon} from '@wuitk/angular/components/common';
import {LabelModule} from '@wuitk/angular/components/label';
import {NotificationContainerModule} from '@wuitk/angular/components/notification';
import {InputNumberModule} from 'primeng/inputnumber';
import {BulkOperationComponent} from '../bulk-operation/component/bulk-operation.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NavigationModule} from "@ispm/navigation/navigation.module";
import {MatMenuModule} from '@angular/material/menu';

@NgModule({
  imports: [
    CoreModule,
    TableModule,
    CheckboxModule,
    PaginatorModule,
    RippleModule,
    SharedModule,
    LayoutModule,
    FormsModule,
    TableModule, // Added DataTableModule
    PaginatorModule,
    NavigationModule,
    TestModule,
    NotesModule,
    TherapiesModule,
    UserModule,
    ClickOutsideModule,
    TranslateModule,
    DynamicFormModule,
    FilterModule,
    ExportModule,
    ContextMenuModule,
    MatMenuModule,
    StoreModule.forFeature('tablelist', tablelistReducer),
    EffectsModule.forFeature([TablelistEffects]),
    DlsCommon,
    LabelModule,
    ReactiveFormsModule,
    NotificationContainerModule,
    InputNumberModule
  ],
  declarations: [...COMPONENTS, WorklistExecuteComponent, BulkOperationComponent],
  providers: [...SERVICES],
  exports: [...COMPONENTS]
})

export class WorklistModule {
}
